import {
    useContext,
    useEffect,
    useState,
} from 'react';

import {
    Button,
    Card,
    Col,
    Container,
    Form,
    Row,
} from 'react-bootstrap';

import { PreviousNextButtons } from '../controls/buttons';
import { RadioControl } from '../controls/radio';
import { TextControl } from '../controls/text';
import {
    BrandingContext,
    GeoContext,
    InsuranceDataContext,
    LayoutContext,
    NotificationsContext,
    SessionContext,
} from '../libs/contexts';
import { asCurrency } from '../libs/i18n';
import {
    ageNearest,
    calculateScenarios,
    getOffers,
} from '../libs/insurance';
import { scrollUp } from '../libs/ui';
import { NeedsAnalysis } from './needs';

export const Quoter = () => {

    const { layout, setLayout } = useContext(LayoutContext);

    const { insuranceData } = useContext(InsuranceDataContext);
    const [ready, setReady] = useState(false);
    const [minValue, setMinValue] = useState(0);
    const [maxValue, setMaxValue] = useState(0);


    useEffect(() => {

        //todo refactor for multiproduct/terms
        if (insuranceData.plans && insuranceData.plans.term10) {
            if (insuranceData.plans.term10.minface) {
                setMinValue(insuranceData.plans.term10.minface);
                setReady(true);
            }
            if (insuranceData.plans.term10.maxface) {
                setMaxValue(insuranceData.plans.term10.maxface);

                setReady(true);
            }
        }

    }, [insuranceData.plans]);

    return (
        <>
            {layout && "needs" === layout.quoterView ?
                <>
                    {ready &&
                        <NeedsAnalysis minFacevalue={minValue} maxFacevalue={maxValue} />
                    }
                </>
                :
                <MainQuoter />
            }
        </>
    );

}

const MainQuoter = () => {


    const { session, setSession } = useContext(SessionContext);
    const { layout, setLayout } = useContext(LayoutContext);
    const [genders, setGenders] = useState({});
    const [smoking, setSmoking] = useState({});
    const [updated, setUpdated] = useState(false);
    const [mustRevalidate] = useState(false);


    useEffect(() => {

        scrollUp();

        let newGenders = {
            "M": "Male",
            "F": "Female"
        };
        setGenders(newGenders);

        let newSmoking = {
            No: "None",
            Yes: "Daily/Weekly",
            Maybe: "On occasion"
        };
        setSmoking(newSmoking);

        ///
        let requirements = { ...layout.requirements };
        requirements.quoter = "pass";

        let newLayout = {
            requirements: requirements
        };

        setLayout(newLayout);

    }, []);

    useEffect(() => {


        if (undefined === session.age || "" === session.age) {
            if (undefined !== session.dob) {
                if (10 === session.dob.length) {
                    let newAge = ageNearest(session.dob);
                    if (newAge) {
                        setSession({ age: newAge });
                    }

                }
            }
        }
        if (undefined !== session.age && "" !== session.age) {
            if (undefined === session.dob || 10 !== session.dob.length) {

                let birthYear = new Date().getFullYear() - parseInt(session.age);

                setSession({
                    dob: birthYear.toString()
                });

            }
        }

    }, [session.age, session.dob]);


    useEffect(() => {


    }, [genders]);

    const onChange = (e) => {

        switch (e.id) {
            case "smoking_general":
                if (["Yes", "No"].includes(e.value)) {
                    setSession({ smoking: "Yes" === e.value ? "1" : "0", smoking_specific: "n/a" });
                } else {
                    setSession({ smoking: null });
                }
                break;
            case "smoking_specific":
                if (["Yes", "No"].includes(e.value)) {
                    // be careful, a "Yes" in this case means this is NOT a smoker (due to negative in question)
                    setSession({ smoking: "Yes" === e.value ? "0" : "1" });
                }
                break;
        }

        validateScreen();
    }

    const validateScreen = () => {


    }

    const showAnalysis = (e) => {

        setLayout({ quoterView: "needs" });

        e.preventDefault();

    }

    return (
        <>
            <Form>
                <Container>
                    <Row className="mt-4 mb-4">
                        <Col>
                            <h3>Get your <span className="text-primary">instant</span> life insurance quote</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-lg-12 col-xl-10">
                            <TextControl label="How old are you?" minValue={1} maxValue={99} title="Please provide us with your age" field="age" placeholder="Age" hasErrors={false} onChange={onChange} required={true} type="number" />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col key="gender" className="col-lg-12 col-xl-10">
                            <RadioControl key="gender" label="What is your gender?" choices={genders} type="horizontal" onChange={onChange} field="gender" />
                        </Col>
                    </Row>
                    <Row className="mt-2">
                        <Col key="smoking" className="col-lg-12 col-xl-10">
                            <RadioControl key="smoking" label="Use of nicotine or tobacco products in the last 12 months?" choices={smoking} type="horizontal" onChange={onChange} field="smoking_general" helpMessage="The following are considered nicotine or tobacco products: using cigarettes, cigarillos, colts, cigars, pipes, chewing tobacco, snuff, e-cigarettes, vaporizers, nicotine gum or patches of any other form of nicotine substitute. Does not include cannabis." />
                        </Col>
                    </Row>

                    {"Maybe" === session.smoking_general &&
                        <Row>
                            <Col key="smoking" className="col-lg-12 col-xl-10">
                                <RadioControl key="smoker" label="In the last 12 months have you ONLY smoked large cigars (12 or less throughout the year)?" type="yesno" onChange={onChange} field="smoking_specific" helpMessage="Does not include cannabis" />
                            </Col>
                        </Row>
                    }

                    <Row>
                        <Col className="col-lg-12 col-xl-10">
                            <TextControl helpMessage={"Must be between $20,000 and $500,000."} minValue={20000} maxValue={500000} label="Desired policy value" title="Please provide us with the desired value" field="facevalue" hasErrors={false} onChange={onChange} required={true} type="dollar" />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-lg-12 col-xl-10">
                            <a onClick={showAnalysis} href="#">Not sure how much coverage you need?</a>
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col className="col-lg-12 col-xl-10">
                            <TermSelector onChange={onChange} />
                        </Col>
                    </Row>

                    <Row>
                        <Col className="col-lg-12 col-xl-10">
                            <RiderSelector onChange={onChange} />
                        </Col>
                    </Row>

                    <Row>
                        <Col className="col-lg-12 col-xl-10">
                            <PremiumLine />
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col className="col-lg-12 col-xl-10">
                            <ContinueLine />
                        </Col>
                    </Row>




                </Container>
            </Form>
        </>
    )

}

const TermSelector = ({ onChange }) => {

    const { insuranceData } = useContext(InsuranceDataContext);
    const { session, setSession } = useContext(SessionContext);
    const [display, setDisplay] = useState(false);
    const [terms, setTerms] = useState({});



    useEffect(() => {

        const undoOffers = (newDisplay) => {
            if (undefined === newDisplay) {
                newDisplay = false;
            }
            setSession({
                offers: false,
                premium: null,
                rider: null
            });
            setDisplay(newDisplay);
        }

        if (undefined !== session.age && undefined !== session.gender && undefined !== session.smoking && null !== session.smoking && undefined !== session.facevalue) {

            if (undefined !== insuranceData && undefined !== insuranceData.plans) {

                if ("" !== session.age && session.age > 0 && "" !== session.facevalue && session.facevalue > 0 && "" !== session.gender) {



                    let result = getOffers({ age: session.age, gender: session.gender, smoker: session.smoking, facevalue: session.facevalue, insuranceData: insuranceData });



                    let newTerms = {};

                    if (result.offers) {

                        if (result.eligibility && result.eligibility.age && result.eligibility.facevalue) {

                            for (let [term, offer] of Object.entries(result.offers)) {
                                let years = term.replace("term", "");
                                newTerms[term] = asCurrency({ amount: offer.base }) + " per month. Price guaranteed for " + years + " years.";
                            }
                            setSession(result);
                            setTerms(newTerms);
                            setDisplay('terms');


                        } else {

                            undoOffers('exception');
                        }

                    } else {
                        if (result.segment) {
                            undoOffers('exception');
                        } else {
                            undoOffers();
                        }


                    }
                } else {
                    undoOffers();
                }


            } else {
                undoOffers();
            }

        } else {
            setDisplay(false);
        }

    }, [session.age, session.gender, session.smoking, session.facevalue, insuranceData.plans]);


    return (<>
        {'terms' === display ?
            <RadioControl key="term" label="Which option suits you best?" choices={terms} type="horizontal" onChange={onChange} field="term_selected" helpMessage="You can remain insured at the end of 10 or 20-year term period but your monthly premiums will likely increase annually." />
            :
            <>
                {'exception' === display ?
                    <><DisqualifiedMessage /></>
                    :
                    <></>
                }
            </>
        }

    </>);

}

const DisqualifiedMessage = () => {

    const { layout } = useContext(LayoutContext);

    return (
        <>
            <p>
                We have products that are better suited to your needs. Please contact us at {layout.phone} or {layout.email}
            </p>
        </>
    );
}


const RiderSelector = ({ onChange }) => {

    const { insuranceData } = useContext(InsuranceDataContext);
    const { session, setSession } = useContext(SessionContext);
    const [ready, setReady] = useState(false);
    const [waiver, setWaiver] = useState("");


    useEffect(() => {


        if (undefined !== session.offers) {

            if (session.offers) {
                let hasWaiver = false;
                //todo refactor in case there's different riders
                for (let [term, offer] of Object.entries(session.offers)) {
                    let newWaiver = "Add total disability waiver for " + asCurrency({ amount: offer.rider }) + " per month?";
                    setWaiver(newWaiver);
                    hasWaiver = true;
                }

                setReady(hasWaiver);
            } else {
                setReady(false);
            }



        }

    }, [session.offers]);


    return (<>
        {ready &&
            <RadioControl key="rider" label={waiver} type="yesno" onChange={onChange} field="rider" helpMessage="A waiver of premium for total disability is an optional benefit provision that is designed to waive the premium if the life insured becomes totally disabled prior to attaining age 60 and remains disabled for 4 consecutive months." />
        }

    </>);

}

const PremiumLine = () => {

    const { session, setSession } = useContext(SessionContext);
    const { layout, setLayout } = useContext(LayoutContext);
    const [ready, setReady] = useState(false);

    useEffect(() => {

        if (session.offers && session.term_selected) {

            let premiumOptions = calculateScenarios({ currentTerm: session.term_selected, rider: session.rider, offers: session.offers, facevalue: session.facevalue });
            if (undefined !== premiumOptions) {
                setSession(premiumOptions);
                setReady(true);
                setLayout({
                    screenReady: true
                });
            } else {
                setReady(false);
                setLayout({
                    screenReady: false
                });
            }

        } else {
            setReady(false);
        }


    }, [session.rider, session.term_selected, session.offers]);

    useEffect(() => {

        if (session.premium && session.premium.includes('$')) {
            setReady(true);
        } else {
            setReady(false);
        }

    }, [session.premium]);

    return (
        <>
            {ready &&
                <>
                    Your premium will be <b>{session.premium}</b> per month and won't increase for {session.term} years.

                </>
            }
        </>
    );

}


const ContinueLine = () => {

    const { session, setSession } = useContext(SessionContext);
    const { layout, setLayout } = useContext(LayoutContext);
    const [ready, setReady] = useState(false);

    useEffect(() => {

        if (session.offers && session.term_selected && session.premium && layout.screenReady) {

            setReady(true);

        } else {
            setReady(false);
        }


    }, [session.rider, session.term_selected, session.offers, session.premium, layout.screenReady]);

    return (
        <>
            {ready &&
                <>

                    {ready &&
                        <PreviousNextButtons enabled={ready} />
                    }



                </>
            }
        </>
    );

}